import {MapProjection} from '../constants/mapProjection';

export const defs: [string, string][] = [
    [MapProjection.EPSG_32633, '+proj=utm +zone=33 +datum=WGS84 +units=m +no_defs'],
    [MapProjection.EPSG_3006, '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'],
    [MapProjection.EPSG_4326, '+proj=longlat +ellps=WGS84 +datum=WGS84 +units=m +no_defs'],
    [MapProjection.EPSG_25833, '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs'],
];
